import { render, staticRenderFns } from "./cerdos.vue?vue&type=template&id=0c037bcc"
import script from "./cerdos.vue?vue&type=script&lang=js"
export * from "./cerdos.vue?vue&type=script&lang=js"
import style0 from "./cerdos.vue?vue&type=style&index=0&id=0c037bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports